import { ApolloCache } from "@apollo/client"

import { evict } from "shared/api/evict"
import { ProductPositionTypename } from "shared/types/Project"

export function evictProductPosition(id: string, cache: ApolloCache<object>) {
  evict({
    cache,
    id,
    typename: ProductPositionTypename
  })
}
